import { Button, Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import Addnewpacakgedrawer from "./Addnewpackagedrawer";
import toast from "react-hot-toast";


export default function Mypackages({
  selectedRow,
  rentalPackages,
  setGroupsList,
  groupsList,
  getGroupsAPI,
  vehicleProfileData,
  getVehicleProfileRentalPackagesAPI,
}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [rows, setRows] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [addNewpackage, setAddNewPackage] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const packageType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.packageType;
  const SubcategroypackageType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.packageType;
  delete SubcategroypackageType?.inverted;

  // Sync props → local state
  useEffect(() => {
    setRows(rentalPackages);
  }, [rentalPackages]);

  const cancelEdit = () => {
    setEditingRowId(null);
    setEditForm({});
  };

  const saveEdit = async () => {
    const payload = {
      id: editForm?.id,
      name: editForm.name,
      totalFreeKm: Number(editForm.totalFreeKm),
      kmPerHr: Number(editForm.kmPerHr),
      costPerKm: Number(editForm.costPerKm),
      costPerHr: Number(editForm?.costPerHr),
      extraKmCost: Number(editForm.extraKmCost),
      weekdayTariff: Number(editForm.weekdayTariff),
      weekendTariff: Number(editForm.weekendTariff),
      packageType: editForm.packageType, // already ID
      groupId: vehicleProfileData[0].vehicleGroupId, // already ID
    };

    try {
      const response = await fetch(`${apiUrl}/api/rentalpackages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        toast.success("Vehicle package detail Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        await getVehicleProfileRentalPackagesAPI(
          vehicleProfileData[0]?.vehicleGroupId,
        );

        setEditingRowId(null);
        setEditForm({});
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  const startEdit = (pkg) => {
    if (editingRowId) return; // block multi-edit
    setEditingRowId(pkg.id);
    setEditForm({ ...pkg });
  };

  const handleChange = (field, value) => {
    setEditForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleModalClose = () => {
    setAddNewPackage(false);
  };

  return (
    <div className="p-6">
      {addNewpackage && (
        <Addnewpacakgedrawer
          vehicleProfileData={vehicleProfileData}
          getVehicleProfileRentalPackagesAPI={
            getVehicleProfileRentalPackagesAPI
          }
          selectedRow={selectedRow}
          groupsList={groupsList}
          addNewpackage={addNewpackage}
          handleModalClose={handleModalClose}
          setAddNewPackage={setAddNewPackage}
          isEditMode={isEditMode}
          selectedPackage={selectedPackage}
        />
      )}
      <div className="flex justify-between">
        <div className="flex gap-2">
          <div className="h-5 w-1 rounded bg-teal-600"></div>
          <h2 className="text-lg font-semibold text-slate-800">
            My Rental pacakge
          </h2>
        </div>
        {!addNewpackage && (
          <Button
            variant="contained"
            onClick={() => {
              setAddNewPackage(true);
            }}
          >
            Add Daily Rental Package
          </Button>
        )}
      </div>
      <table className="w-full border border-gray-300 text-sm mt-4">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1">Name</th>
            <th className="border px-2 py-1">Total Free Km</th>
            <th className="border px-2 py-1">Km / Hr</th>
            <th className="border px-2 py-1">Cost / Hr</th>
            <th className="border px-2 py-1">Extra Km Cost</th>
            <th className="border px-2 py-1">Weekday Rent</th>
            <th className="border px-2 py-1">Weekend Rent</th>
            <th className="border px-2 py-1">Type</th>
            <th className="border px-2 py-1">Group</th>
            <th className="border px-2 py-1">Created On</th>
            <th className="border px-2 py-1">Action</th>
          </tr>
        </thead>

        <tbody>
          {rows.length > 0 ? (
            rows.map((pkg) => {
              const isEditing = editingRowId === pkg.id;

              return (
                <tr key={pkg.id} className="border-t">
                  {/* Name */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        className="border px-1 w-full"
                        value={editForm.name ?? ""}
                        onChange={(e) => handleChange("name", e.target.value)}
                      />
                    ) : (
                      pkg.name
                    )}
                  </td>

                  {/* Total Free Km */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.totalFreeKm ?? ""}
                        onChange={(e) =>
                          handleChange("totalFreeKm", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.totalFreeKm
                    )}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.kmPerHr ?? ""}
                        onChange={(e) =>
                          handleChange("kmPerHr", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.kmPerHr
                    )}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.costPerHr ?? ""}
                        onChange={(e) =>
                          handleChange("costPerHr", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.costPerHr
                    )}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.extraKmCost ?? ""}
                        onChange={(e) =>
                          handleChange("extraKmCost", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.extraKmCost
                    )}
                  </td>

                  {/* Weekday Tariff */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.weekdayTariff ?? ""}
                        onChange={(e) =>
                          handleChange("weekdayTariff", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.weekdayTariff
                    )}
                  </td>

                  {/* Weekend Tariff */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.weekendTariff ?? ""}
                        onChange={(e) =>
                          handleChange("weekendTariff", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.weekendTariff
                    )}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {packageType[pkg.packageType]}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {
                      groupsList.filter((item) => item?.id === pkg.groupId)[0]
                        ?.name
                    }
                  </td>

                  {/* Created On */}
                  <td className="border px-2 py-1 text-center">
                    {pkg.createdAt}
                  </td>

                  {/* Action */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <>
                        <button
                          onClick={saveEdit}
                          className="bg-green-500 text-white px-2 py-1 mr-2"
                        >
                          Save
                        </button>
                        <button
                          onClick={cancelEdit}
                          className="bg-gray-400 text-white px-2 py-1"
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={() => startEdit(pkg)}
                        className="bg-blue-500 text-white px-2 py-1"
                      >
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <div className="text-center mt-4 font-semibold">
              No Package Details Found
            </div>
          )}
        </tbody>
      </table>
    </div>
  );
}
